<template>
  <div class="toast-message">
    <div class="toast-message__content">
      <div class="toast-message__inner-icon" v-if="props.message.type">
        <TirPmStatusBudge
          status-icon-type="info"
          status-color="info-invert"
          v-if="props.message.type == 'info'"
        />
        <TirPmStatusBudge
          status-icon-type="positive"
          status-color="positive-invert"
          v-if="props.message.type == 'success'"
        />
        <TirPmStatusBudge
          status-icon-type="alert"
          status-color="alert-invert"
          v-if="props.message.type == 'warn'"
        />
        <TirPmStatusBudge
          status-icon-type="negative"
          status-color="negative-invert"
          v-if="props.message.type == 'error'"
        />
        <TirPmStatusBudge
          status-icon-type="blocking"
          status-color="blocking-invert"
          v-if="props.message.type == 'block'"
        />
      </div>

      <div class="toast-message__content-detail">
        <div class="toast-message__content-title">
          {{ message.title }}
        </div>
        <div
          class="toast-message__content-container-button"
          v-if="props.message.labelButton"
        >
          <TirPmButton
            :variant="TirPmButtonVariantEnum.LinkInvertState"
            :size="TirPmButtonSizeEnum.Small"
            @click="props.message.callbackButton()"
            >{{ message.labelButton }}</TirPmButton
          >
        </div>
      </div>
    </div>
    <div
      v-if="message.closable"
      class="toast-message__close"
      @click="onCloseClick"
    >
      <XMarkIcon />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  PropType,
  onMounted,
  onUnmounted,
  ref,
  defineProps,
  defineEmits
} from 'vue'
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum
} from 'tir-pm-button'
import { TirPmStatusBudge } from 'tir-pm-status-budge'
import { ToastMessageModel } from '../index'
import { XMarkIcon } from 'tir-style-system/icons/solid'

// import {
//   ExclamationCircleIcon,
//   InformationCircleIcon,
//   CheckCircleIcon,
//   XCircleIcon,
// } from "./icon";
// import { XMarkIcon } from "@heroicons/vue/24/outline";

/**Параметры компонента */
const props = defineProps({
  message: { type: Object as PropType<ToastMessageModel>, default: null }
})
/**События компонента */
const emit = defineEmits(['close'])

/**Таймер на закрытие компонента */
const closeTimeout = ref<any>(null)

/**После рендера компонента */
onMounted(() => {
  if (props.message.life)
    closeTimeout.value = setTimeout(
      () => close({ message: props.message, type: 'life-end' }),
      props.message.life
    )
})
/**После удаления компонента */
onUnmounted(() => clearCloseTimeout())

/**Отправка события о закрытии компонента */
const close = (params: any) => emit('close', params)
/**Очистка таймера на закрытие сообщения */
const clearCloseTimeout = () => {
  if (!closeTimeout.value) return
  clearTimeout(closeTimeout.value)
  closeTimeout.value = null
}
/**Клик по кнопке закрытия сообщения */
const onCloseClick = () => {
  clearCloseTimeout()
  close({ message: props.message, type: 'close' })
}
</script>
<style lang="scss">
@import './style.scss';
</style>
